import { motion } from "framer-motion";
import { ATHENA } from "@/constants/testIds";

const PARTNERS = [
  "NATURE MEETS SCIENCE",
  "EVIDENCE FIRST",
  "MOLECULE TO MANUSCRIPT",
  "TRACEABLE BY DESIGN",
  "SCIENCE WITH CONSEQUENCE",
  "BUILT ON PROOF",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid={ATHENA.aboutSection}
      className="relative pt-8 md:pt-10 pb-12 md:pb-16 border-t border-[#D5D1C8]"
    >
      {/* marquee */}
      <div className="overflow-hidden border-y border-[#D5D1C8] py-5 mb-12">
        <div className="marquee-track gap-16 label-mono text-[#3D4F46]">
          {[...PARTNERS, ...PARTNERS].map((p, i) => (
            <span key={i} className="flex items-center gap-16 whitespace-nowrap">
              {p}
              <span className="w-1 h-1 rounded-full bg-[#B89B64]" />
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <span className="label-mono">// OUR MISSION</span>
        <motion.h2
          data-testid={ATHENA.missionStatement}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9 }}
          className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-[#0A1713] mt-4"
        >
          We bridge the
          <em className="italic text-[#1A382A]"> intelligence </em>
          of biotechnology with the
          <em className="italic text-[#B89B64]"> wisdom </em>
          of nature — building therapies, ingredients and platforms that endure.
        </motion.h2>
        <div className="mt-6 max-w-2xl mx-auto text-[#3D4F46] leading-relaxed">
          Built by a team of formulation chemists and clinicians, Athena
          Nutrascience operates through GMP facilities and translational
          research labs. We work with brands, hospitals
          <br />
          and university programs across India, the EU and North America.
        </div>
      </div>
    </section>
  );
};

export default About;
